module.exports = __webpack_public_path__ + "img/logo-mini.cdef71a8.svg";